module.exports = __webpack_public_path__ + "img/yanbao2.9a0b3185.png";